import React from "react";
import { Container } from "react-bootstrap";
import Wrapper from "../Components/Wrapper";
import Herosection from "../Components/Herosection";
import { useLocation } from "react-router-dom";

function Notes() {
  const { state } = useLocation();
  // console.log(state);

  return (
    <Wrapper>
      <Herosection title={"Notes"} />

      <div className="notesWrapper py-md-5 py-3">
        <Container>
          <div className="tabs-wrapper p-3 rounded-4">
            <iframe
              title="nots"
              src={state.pdf}
              width="100%"
              height="700px"
            ></iframe>
          </div>
        </Container>
      </div>
    </Wrapper>
  );
}

export default Notes;
